import React from 'react';


const CourseComment = React.lazy(() => import('./component/home/course/courseComment/CourseComment.jsx'));
const CourseQuestion = React.lazy(() => import('./component/home/course/courseQuestion/CourseQuestion.jsx'));
const MainPage = React.lazy(() => import('./component/main/MainPage.jsx'));
const MyChooseLanguagePage = React.lazy(() => import('./component/base/MyChooseLanguage.jsx'));
const AboutUs = React.lazy(() => import('./component/profile/info/AboutUs'));

export default [
    {path: '/course/:courseId/comment', name: 'دیدگاه ها', component: CourseComment},
    {path: '/course/:courseId/question', name: 'ارتباط با استاد', component: CourseQuestion},
    {path: '/aboutus', name: 'درباره ما', component: AboutUs},
    {path: '/chooseLanguage', name: 'انتخاب زبان', component: MyChooseLanguagePage},
    {path: '/*', name: 'خانه', component: MainPage}
];
